import React, {useEffect} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, pointer, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {useUserDevice} from "@pg-mono/user-device";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {gtmHeroBanerClick, gtmHeroBanerShow} from "../../tracking/google_tag_manager/gtm_hero_banner";
import {IHeroCreation} from "../types/IHeroCreation";

interface IProps {
    creation: IHeroCreation;
    url: string;
    preventGtmOnMobile?: boolean;
}

export const HeroCreation = (props: IProps) => {
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (props.preventGtmOnMobile && isMobile) {
            return;
        }

        gtmHeroBanerShow();
    }, []);

    const onRedirectToUrlClick = () => {
        if (!props.preventGtmOnMobile || !isMobile) {
            gtmHeroBanerClick();
        }

        window.open(props.url, "_blank");
    };

    if (isMobile) {
        return (
            <HeroBox onClick={onRedirectToUrlClick}>
                <Image css={borderRadius(2)} alt="creation" width="375" height="484" ratio={{xs: "366/442"}} src={props.creation.mobile_image?.m_img_375x484} />
            </HeroBox>
        );
    }

    return (
        <div css={heroBanner}>
            <Image
                onClick={onRedirectToUrlClick}
                css={heroBannerImage}
                src={props.creation.desktop_image}
                fetchPriority="high"
                alt="hero banner"
                width="1536"
                height="295"
            />
        </div>
    );
};

const heroBanner = css`
    ${w100};
    max-width: 1536px;
    min-width: 984px;
    height: auto;
    ${borderRadius(2)};
    ${elevation(2)};
    overflow: hidden;
    line-height: 0;
    ${pointer};
`;

const heroBannerImage = css`
    width: 100%;
    height: auto;

    img {
        object-fit: cover;
        width: 100%;
        height: auto;
    }
`;

const HeroBox = styled(OfferBoxBase)`
    height: 100%;
    margin: 0 auto;
    ${pointer};

    img {
        height: 100%;
    }
`;
